import {keyBingMap} from './configuracion.js';
import {Tile as TileLayer} from 'ol/layer.js';
import BingMaps from 'ol/source/BingMaps.js';
import OSM from 'ol/source/OSM';
import TileArcGISRest from 'ol/source/TileArcGISRest.js';

//
// Mapas base
//
export const cartaNacional100K = new TileLayer({
  id : 'cartaNacional100K',
  visible: false,  
  source: new TileArcGISRest({
    attribution: '<a href="https://www.gob.pe/pcm" target="_blank">&copy; Secretaria de Demarcación y Organización Territorial</a>',
    url: 'https://www.idep.gob.pe/geoportal/rest/services/MAPA_BASE/PER%C3%9A_RASTER_100KKT/MapServer',
  })
});
export const cartaNacional100KACT = new TileLayer({
  id : 'cartaNacional100KACT',
  visible: false,  
  source: new TileArcGISRest({
    attribution: '<a href="https://www.gob.pe/pcm" target="_blank">&copy; Secretaria de Demarcación y Organización Territorial</a>',
    url: 'https://portalgeo.idep.gob.pe/geoportal/rest/services/MAPA_BASE/PER%C3%9A_RASTER_100KACTUALIZADO/MapServer',
  })
});
export const cartaNacional25K = new TileLayer({
  id : 'cartaNacional25K',
  visible: false,  
  source: new TileArcGISRest({
    attribution: '<a href="https://www.gob.pe/pcm" target="_blank">&copy; Secretaria de Demarcación y Organización Territorial</a>',
    url: 'https://portalgeo.idep.gob.pe/geoportal/rest/services/MAPA_BASE/PER%C3%9A_RASTERP_25K/MapServer',
  })
});
export const arcgisLightGray = new TileLayer({
  id : 'arcgisLightGray',
  visible: false,  
  source: new TileArcGISRest({
    attribution: '<a href="https://www.gob.pe/pcm" target="_blank">&copy; Secretaria de Demarcación y Organización Territorial</a>',
    url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer',
  })
});
export const arcgisWorldTopo = new TileLayer({
  id : 'arcgisWorldTopo',
  visible: false,
  source: new TileArcGISRest({
    attribution: '<a href="https://www.gob.pe/pcm" target="_blank">&copy; Secretaria de Demarcación y Organización Territorial</a>',
    url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer',
  })
});
export const arcgisWorldImagery = new TileLayer({
  id : 'arcgisWorldImagery',
  visible: true,
  source: new TileArcGISRest({
    attribution: '<a href="https://www.gob.pe/pcm" target="_blank">&copy; Secretaria de Demarcación y Organización Territorial</a>',
    url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer',
  })
});
/* export const bingMapRoadOnDemand = new TileLayer({
  id : 'bingMapRoadOnDemand',
  visible: false,
  preload: Infinity,
  source: new BingMaps({
    key: keyBingMap,
    imagerySet: 'RoadOnDemand',
    placeholderTiles: false,
  })
});
export const bingMapAerial = new TileLayer({
  id : 'bingMapAerial',
  visible: false,
  preload: Infinity,
  source: new BingMaps({
    key: keyBingMap,
    imagerySet: 'Aerial',
    placeholderTiles: false,
  })
});
export const bingMapAerialWithLabelsOnDemand = new TileLayer({
  id : 'bingMapAerialWithLabelsOnDemand',
  visible: false,
  preload: Infinity,
  source: new BingMaps({
    key: keyBingMap,
    imagerySet: 'AerialWithLabelsOnDemand',
    placeholderTiles: false,
  })
});
export const bingMapCanvasDark = new TileLayer({
  id : 'bingMapCanvasDark',
  visible: false,
  preload: Infinity,
  source: new BingMaps({
    key: keyBingMap,
    imagerySet: 'CanvasDark',
    placeholderTiles: false,
  })
}); */
export const osm = new TileLayer({
  id : 'osm',
  visible: false, 
  type: 'base',
  title: 'OSM',
  source: new OSM()
});

let elementosLista = document.querySelectorAll('#capasBase .list-group-item');
elementosLista.forEach(function(elemento){  
  elemento.addEventListener('click', function(event){
    event.preventDefault();
    elementosLista.forEach(function(el) {
      el.classList.remove('active');
    });
    if(this.id === 'capaBase01') {
      this.classList.add('active');
      arcgisLightGray.setVisible(true);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(false);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase02') {
      this.classList.add('active');
      arcgisLightGray.setVisible(false);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(true);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(false);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase03') {
      this.classList.add('active');
      arcgisLightGray.setVisible(false);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(true);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(false);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase04') {
      this.classList.add('active');
      arcgisLightGray.setVisible(false);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(true);
      osm.setVisible(false);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase05') {
      this.classList.add('active');
      arcgisLightGray.setVisible(false);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(true);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase06') {
      this.classList.add('active');
      arcgisLightGray.setVisible(false);
      arcgisWorldTopo.setVisible(true);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(false);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase07') {
      this.classList.add('active');
      arcgisLightGray.setVisible(true);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(false);
      cartaNacional100K.setVisible(true);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase08') {
      this.classList.add('active');
      arcgisLightGray.setVisible(true);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(false);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(true);
      cartaNacional25K.setVisible(false);
    }
    if(this.id === 'capaBase09') {
      this.classList.add('active');
      arcgisLightGray.setVisible(true);
      arcgisWorldTopo.setVisible(false);
      /*bingMapAerial.setVisible(false);
      bingMapAerialWithLabelsOnDemand.setVisible(false);*/
      arcgisWorldImagery.setVisible(false);
      osm.setVisible(false);
      cartaNacional100K.setVisible(false);
      cartaNacional100KACT.setVisible(false);
      cartaNacional25K.setVisible(true);
    }
  });
});